const scrollBeforeLoad = scrollTo => {
  if (scrollTo) {
    document.scrollingElement.scrollTo(0, scrollTo);
    preventTurboOverridingScroll();
  }
};
const preventTurboOverridingScroll = () => {
  if (Turbo.navigator.currentVisit) {
    Turbo.navigator.currentVisit.scrolled = true;
  }
};
export default scrollBeforeLoad;